import React from 'react';
import resumePDF from '../Resume/BaitaResume.pdf';

export default function ResumeSection() {
  return (
    <section id="resume" className="section section-alt">
      <div className="section-content">
        <h2 className="section-title">Resume</h2>
        <p>
          A snapshot of my professional background.
        </p>

        {/* ── Profile Summary ── */}
        <div className="resume-profile">
          <div className="resume-profile-heading">
            <h3 className="resume-name gradient-text">Jhon Jeremie Escorial Baita</h3>
            <span className="resume-tagline">Computer Engineering Student • Aspiring Software Developer</span>
          </div>
          <p className="resume-objective">
            Passionate and driven Computer Engineering student focused on building scalable,
            user-centric applications. Seeking opportunities to contribute to meaningful software
            projects while growing as a full-stack developer and future engineering team leader.
          </p>
        </div>

        {/* ── Stats Bar ── */}
        <div className="resume-stats">
          <div className="resume-stat">
            <span className="resume-stat-number gradient-text">19</span>
            <span className="resume-stat-label">Projects</span>
          </div>
          <div className="resume-stat">
            <span className="resume-stat-number gradient-text">10</span>
            <span className="resume-stat-label">Certificates</span>
          </div>
          <div className="resume-stat">
            <span className="resume-stat-number gradient-text">1</span>
            <span className="resume-stat-label">Competition</span>
          </div>
          <div className="resume-stat">
            <span className="resume-stat-number gradient-text">3rd</span>
            <span className="resume-stat-label">Year CpE</span>
          </div>
        </div>

        {/* ── Download Actions ── */}
        <div className="resume-actions" style={{ marginTop: '3rem' }}>
          <a className="button primary-btn resume-btn" href={resumePDF} download="Jhon_Jeremie_Baita_Resume.pdf">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download Resume PDF
          </a>
          <a className="button secondary-btn resume-btn" href={resumePDF} target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            View Resume
          </a>
        </div>

      </div>
    </section>
  );
}
